import * as React from "react"

import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default function Icon() {

  useGSAP(() => {

    let tl = gsap.timeline({
      defaults: {
        duration: 1.2,
        ease: 'power1.inOut',
      },
      scrollTrigger: {
        trigger: "#icon-exclamation",
        start: "bottom bottom",
        end: "bottom+=50px bottom",
        markers: false,
        toggleActions: "play none play reset"
      }
    });

    tl.from('.circle, .exclam', { 
        duration: 0.5,
        scale: 0,
        opacity: 0,
        transformOrigin: "center center",
        stagger: 0.5,
      })
      .to('.circle, .exclam', {
        scale: 1,
        opacity: 1,
      })
      // .to('g', {
      //   strokeDashoffset: 0,
      // })
  });

 return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115.13 118.01" id="icon-exclamation">
    <path fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M83.7 103.85v3.39c0 4.84-3.93 8.77-8.77 8.77H10.77c-4.84 0-8.77-3.93-8.77-8.77V23.93c0-4.84 3.93-8.77 8.77-8.77h15.74m32.68 0h15.74c4.84 0 8.77 3.93 8.77 8.77v5.58"/>
    <path fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M51.51 11.84c.04-.36.11-.7.11-1.07 0-4.84-3.93-8.77-8.77-8.77s-8.77 3.93-8.77 8.77c0 .37.06.72.11 1.07-7.8 2.02-13.26 6.67-13.26 12.09h43.85c0-5.42-5.46-10.07-13.26-12.09h0ZM14.97 46.11h29.7v.23h-29.7zm0 14.65h29.7v.23h-29.7zm0 14.64h29.7v.23h-29.7zm0 14.65h29.7v.23h-29.7z"/>

    <circle className="circle" cx="83.9" cy="66.28" r="29.23" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" />
    <g className="exclam">
      <rect width="8.26" height="26.02" x="79.77" y="45.66" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" rx="4.13" ry="4.13" />
      <rect width="8.26" height="8.26" x="79.77" y="78.64" fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" rx="4.13" ry="4.13" />
    </g>
  </svg>
 );
}